const makeHeading2 = ({text} = {}) => ({
  type: 'heading2',
  children: [
    {
      text: text || '',
    },
  ],
});

export default makeHeading2;
